import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const mainContentElement = document.getElementById('main-content');
    if (mainContentElement) {
      mainContentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use 'instant' to avoid smooth scroll interference
      });
    } else {
      // Fallback attempt if the element isn't found immediately (less likely needed now)
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;